"use client";

import type {
  FranchiseInquiry as FranchiseInquiryProps,
  PlaceholderValues,
} from "@homeinstead/schemas";
import type { PortableTextBlock } from "next-sanity";

import { FranchiseInquiryLeadForm } from "~www/components/LeadForm/FranchiseInquiry";
import { InquiryIntroSection } from "~www/components/LeadForm/Inquiry";
import { usePageBuilderDocumentId } from "~www/components/PageBuilder/page-builder-runtime-context";

type FranchiseInquiryBlockProps = Omit<FranchiseInquiryProps, "_type"> & {
  /** Sanity block key within the page document */
  _key: string;
  /** Set by `Content` */
  placeholders?: PlaceholderValues;
  /** Sanity page document id — set by `PageBuilder` */
  pageDocumentId?: string;
};

function FranchiseInquiry({
  _key: blockKey,
  initialStep,
  notificationEmail,
  pageDocumentId,
  senderEmail,
  textColor,
}: FranchiseInquiryBlockProps) {
  const pageDocumentIdFromContext = usePageBuilderDocumentId();
  const resolvedPageDocumentId =
    pageDocumentId ?? pageDocumentIdFromContext ?? undefined;

  if (
    !initialStep?.length ||
    !notificationEmail ||
    !senderEmail ||
    !blockKey ||
    !resolvedPageDocumentId
  ) {
    return null;
  }

  return (
    <InquiryIntroSection
      ctaElementName="franchise_inquiry_start"
      ctaLabel="Enquire Now"
      initialStep={initialStep as PortableTextBlock[]}
      textColor={textColor}
    >
      <FranchiseInquiryLeadForm
        blockKey={blockKey}
        pageDocumentId={resolvedPageDocumentId}
        textColor={textColor}
      />
    </InquiryIntroSection>
  );
}

export type { FranchiseInquiryBlockProps };

export { FranchiseInquiry };
